import SmallNav from './SmallNav';

export * from './SmallNav';

export default SmallNav;
